export class DOMUtil {
    static rectEquals(rect1: DOMRect, rect2: DOMRect) {
        return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height;
    }

    static randomElementId(prefix: string) {
        return prefix + Math.floor(Math.random() * 0x100000000).toString(16).padStart(8, '0')
    }
}